import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, auth } from "../lib/api";
import { toast } from "sonner";
import BrandHeader from "../components/BrandHeader";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw1.length < 8) return toast.error("Use at least 8 characters.");
    if (pw1 !== pw2) return toast.error("Passwords don't match.");
    setBusy(true);
    try {
      const r = await api.post("/auth/set-password", { token, password: pw1 });
      auth.setSession(r.data.access_token, r.data.email);
      toast.success("Password set — you're signed in.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't set password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <BrandHeader />
      <main className="max-w-md mx-auto px-4 sm:px-6 py-10">
        <div className="rounded-xl bg-white border border-neutral-200 p-6 sm:p-8">
          <h1 className="font-display text-2xl font-semibold text-neutral-900 mb-1">
            Set your admin password
          </h1>
          <p className="text-sm text-neutral-500 mb-6">
            Choose a password of at least 8 characters. You'll be signed in immediately after.
          </p>
          {!token ? (
            <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-900" data-testid="no-token-banner">
              This page needs a valid setup link. Please request a new link from the sign-in page.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="set-password-form">
              <div>
                <Label className="text-sm text-neutral-700 mb-1 block">New password</Label>
                <Input
                  type="password"
                  value={pw1}
                  onChange={(e) => setPw1(e.target.value)}
                  className="h-11"
                  data-testid="new-password"
                  required
                  autoComplete="new-password"
                />
              </div>
              <div>
                <Label className="text-sm text-neutral-700 mb-1 block">Confirm password</Label>
                <Input
                  type="password"
                  value={pw2}
                  onChange={(e) => setPw2(e.target.value)}
                  className="h-11"
                  data-testid="confirm-password"
                  required
                  autoComplete="new-password"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                data-testid="btn-set-password"
                className="h-11 w-full bg-[#2D5A4F] hover:bg-[#264d43] text-white"
              >
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Set password & sign in"}
              </Button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
